import { rachelZoePageData } from '@data-ts/pages/rachel-zoe';
import { CurationProps } from './Curation';

const curatedRegistrySectionData = rachelZoePageData.sections.curatedRegistry;

export const curationsData: CurationProps[] = [
  {
    pageUrl: '/shop/curations/host-a-stylish-dinner-party',
    marginBottom: [13, 12],
    videoImages: {
      title: curatedRegistrySectionData.hosting.title,
      video: '',
      backgroundVideo: '',
      videoPoster: 'rachel zoe/curations/1/cover-pic.jpg',
      images: [
        {
          url: 'rachel zoe/curations/bg-art/dot.svg',
          belowSm: {
            width: 12,
            height: 12,
            top: 303,
            right: 146,
            zIndex: 4,
            show: true,
            borderRadius: '50%',
            showBoxShadow: true,
          },
          sm: {
            width: 20,
            height: 20,
            top: -190,
            left: 648,
            zIndex: 4,
            show: true,
            borderRadius: '50%',
            showBoxShadow: true,
          },
        },
        {
          url: 'rachel zoe/curations/1/wine-glasses.jpg',
          belowSm: {
            width: 98,
            height: 98,
            top: -27,
            right: 116,
            zIndex: 4,
            show: true,
            showBoxShadow: true,
          },
          sm: {
            width: 242,
            height: 242,
            top: 228,
            right: 330,
            zIndex: 4,
            show: true,
            showBoxShadow: true,
          },
        },
        {
          url: 'rachel zoe/curations/1/vase.jpg',
          belowSm: {
            width: 104,
            height: 104,
            top: 161,
            right: 116,
            zIndex: 4,
            show: true,
            showBoxShadow: true,
          },
          sm: {
            width: 176,
            height: 176,
            top: -37,
            right: 490,
            show: true,
            showBoxShadow: true,
          },
        },
        {
          url: 'rachel zoe/curations/bg-art/curl.svg',
          belowSm: {
            width: 315,
            height: 304,
            top: 65,
            right: -10,
            zIndex: 1,
            rotate: 255,
            show: true,
          },
          sm: {
            width: 478,
            height: 461,
            top: 225,
            right: 450,
            zIndex: 1,
            rotate: 190,
            show: true,
          },
        },
        {
          url: 'rachel zoe/curations/1/stand.jpg',
          belowSm: {
            width: 122,
            height: 97,
            top: -48,
            left: 111,
            zIndex: 2,
            show: true,
            showBoxShadow: true,
          },
          sm: {
            width: 273,
            height: 219,
            top: -37,
            left: 282,
            zIndex: 2,
            show: true,
            showBoxShadow: true,
          },
        },
        {
          url: 'rachel zoe/curations/1/champ-glasses.jpg',
          belowSm: {
            width: 98,
            height: 98,
            top: 80,
            left: 135,
            zIndex: 4,
            show: true,
            showBoxShadow: true,
          },
          sm: {
            width: 138,
            height: 138,
            top: 93,
            left: 613,
            zIndex: 2,
            show: true,
            showBoxShadow: true,
          },
        },
        {
          url: 'rachel zoe/curations/1/plates.jpg',
          belowSm: {
            width: 111,
            height: 88,
            top: 206,
            left: 24,
            zIndex: 4,
            show: true,
            showBoxShadow: true,
          },
          sm: {
            width: 303,
            height: 242,
            top: 280,
            left: 430,
            show: true,
            showBoxShadow: true,
          },
        },
        {
          url: 'rachel zoe/curations/bg-art/curl.svg',
          belowSm: {
            width: 1,
            height: 1,
            showBoxShadow: true,
          },
          sm: {
            width: 645,
            height: 622,
            top: -220,
            left: 275,
            rotate: 6,
            zIndex: 1,
            show: true,
          },
        },
      ],
    },
  },
  {
    pageUrl: '/shop/curations/style-organize-a-bar-cart',
    marginBottom: [14, 12],
    videoImages: {
      title: curatedRegistrySectionData.kitchen.title,
      video: '',
      backgroundVideo: '',
      videoPoster: 'rachel zoe/curations/2/cover-pic.jpg',
      images: [
        {
          url: 'rachel zoe/curations/bg-art/dot.svg',
          belowSm: {
            width: 12,
            height: 12,
            top: 260,
            left: 150,
            zIndex: 4,
            show: true,
            borderRadius: '50%',
            showBoxShadow: true,
          },
          sm: {
            width: 20,
            height: 20,
            top: 0,
            right: 630,
            zIndex: 4,
            show: true,
            borderRadius: '50%',
            showBoxShadow: true,
          },
        },
        {
          url: 'rachel zoe/curations/2/cocktail.jpg',
          belowSm: {
            width: 104,
            height: 104,
            top: 160,
            right: 115,
            zIndex: 4,
            show: true,
            showBoxShadow: true,
          },
          sm: {
            width: 160,
            height: 160,
            top: 233,
            right: 618,
            zIndex: 4,
            show: true,
            borderRadius: '50%',
            showBoxShadow: true,
          },
        },
        {
          url: 'rachel zoe/curations/2/ice.jpg',
          belowSm: {
            width: 98,
            height: 98,
            top: -41,
            right: 97,
            zIndex: 2,
            show: true,
            showBoxShadow: true,
          },
          sm: {
            width: 273,
            height: 219,
            top: 63,
            zIndex: 2,
            right: 305,
            show: true,
            showBoxShadow: true,
          },
        },
        {
          url: 'rachel zoe/curations/bg-art/curl.svg',
          belowSm: {
            width: 315,
            height: 304,
            top: 75,
            right: -30,
            zIndex: 1,
            rotate: 105,
            show: true,
          },
          sm: {
            width: 564,
            height: 544,
            top: 65,
            right: 255,
            zIndex: 1,
            rotate: 195,
            show: true,
          },
        },
        {
          url: 'rachel zoe/curations/2/holder.jpg',
          belowSm: {
            width: 98,
            height: 98,
            top: 175,
            left: 42,
            zIndex: 4,
            borderRadius: '50%',
            show: true,
            showBoxShadow: true,
          },
          sm: {
            width: 184,
            height: 184,
            top: 414,
            right: 314,
            zIndex: 4,
            show: true,
            borderRadius: '50%',
            showBoxShadow: true,
          },
        },
        {
          url: 'rachel zoe/curations/2/shaker.jpg',
          belowSm: {
            width: 122,
            height: 97,
            top: -48,
            left: 111,
            zIndex: 4,
            show: true,
            showBoxShadow: true,
          },
          sm: {
            width: 303,
            height: 242,
            top: 260,
            left: 320,
            zIndex: 5,
            show: true,
            showBoxShadow: true,
          },
        },
        {
          url: 'rachel zoe/curations/2/decanter.jpg',
          belowSm: {
            width: 104,
            height: 104,
            top: 160,
            right: 115,
            zIndex: 4,
            show: true,
            showBoxShadow: true,
          },
          sm: {
            width: 190,
            height: 190,
            top: 27,
            left: 485,
            zIndex: 2,
            show: true,
            showBoxShadow: true,
          },
        },
      ],
    },
  },
  {
    pageUrl: '/shop/curations/decorate-your-dream-living-room',
    marginBottom: [12, 11],
    videoImages: {
      title: curatedRegistrySectionData.livingRoom.title,
      video: '',
      backgroundVideo: '',
      videoPoster: 'rachel zoe/curations/3/cover-pic.jpg',
      images: [
        {
          url: 'rachel zoe/curations/2/book.jpg',
          belowSm: {
            width: 1,
            height: 1,
            show: false,
          },
          sm: {
            width: 138,
            height: 138,
            top: 90,
            right: 546,
            zIndex: 2,
            show: true,
            showBoxShadow: true,
          },
        },
        {
          url: 'rachel zoe/curations/3/pillow.jpg',
          belowSm: {
            width: 111,
            height: 88,
            top: 100,
            left: 114,
            zIndex: 4,
            borderRadius: '4px',
            show: true,
            showBoxShadow: true,
          },
          sm: {
            width: 303,
            height: 242,
            top: 282,
            zIndex: 2,
            right: 287,
            show: true,
            showBoxShadow: true,
          },
        },
        {
          url: 'rachel zoe/curations/bg-art/curl.svg',
          belowSm: {
            width: 287,
            height: 277,
            top: 105,
            left: -120,
            zIndex: 1,
            rotate: 275,
            flip: true,
            show: true,
          },
          sm: {
            width: 645,
            height: 622,
            top: 10,
            right: 95,
            zIndex: 1,
            rotate: 70,
            show: true,
          },
        },
        {
          url: 'rachel zoe/curations/3/game.jpg',
          belowSm: {
            width: 98,
            height: 98,
            top: 157,
            right: 114,
            zIndex: 5,
            show: true,
            showBoxShadow: true,
          },
          sm: {
            width: 273,
            height: 219,
            top: 63,
            left: 330,
            zIndex: 5,
            show: true,
            showBoxShadow: true,
          },
        },
        {
          url: 'rachel zoe/curations/3/lamp.jpg',
          belowSm: {
            width: 88,
            height: 88,
            top: -48,
            left: 112,
            zIndex: 2,
            borderRadius: '50%',
            show: true,
            showBoxShadow: true,
          },
          sm: {
            width: 220,
            height: 220,
            top: 380,
            left: 450,
            zIndex: 2,
            borderRadius: '50%',
            show: true,
            showBoxShadow: true,
          },
        },
        {
          url: 'rachel zoe/curations/bg-art/dot.svg',
          belowSm: {
            width: 12,
            height: 12,
            top: 115,
            right: 175,
            zIndex: 4,
            show: true,
            borderRadius: '50%',
            showBoxShadow: true,
          },
          sm: {
            width: 20,
            height: 20,
            top: 295,
            left: 650,
            zIndex: 4,
            show: true,
            borderRadius: '50%',
            showBoxShadow: true,
          },
        },
        {
          url: 'rachel zoe/curations/bg-art/curl.svg',
          belowSm: {
            width: 1,
            height: 1,
          },
          sm: {
            width: 404,
            height: 390,
            top: 140,
            left: 160,
            zIndex: 1,
            rotate: 95,
            show: true,
          },
        },
      ],
    },
  },
];
